import { paginationSize } from '../../../constants/constants';
import { FETCH_VISITS_REPORT_START, FETCH_VISITS_REPORT_SUCCESS, FETCH_VISITS_REPORT_ERROR, SET_VISITS_REPORT_PAGINATION, RESET_VISITS_REPORT, FETCH_PAYMENTS_REPORT, FETCH_PAYMENTS_REPORT_START, FETCH_PAYMENTS_REPORT_SUCCESS, FETCH_PAYMENTS_REPORT_ERROR, SET_PAYMENTS_REPORT_PAGINATION,RESET_PAYMENTS_REPORT } from '../../actions/admin/visitsReportAction';
import _ from 'lodash';

const INIT_STATE = {
    error: "",
    loading: false,
    message: '',
    visitsReport: [],
    pagination: {
        currentPage: 1,
        pageSize: paginationSize,
        totalPages: 0,
        totalItems: 0,
    },
};

const visitsReportReducer = (state = INIT_STATE, action) => {
    switch (action.type) {
        case FETCH_VISITS_REPORT_START: {
            return { ...state, error: '', message: '', loading: true };
        }
        case FETCH_VISITS_REPORT_SUCCESS: {
            return { ...state, error: '', message: '', loading: false, visitsReport: _.cloneDeep(action.visitsReport) };
        }
        case FETCH_VISITS_REPORT_ERROR: {
            return { ...state, loading: false, error: action.error, message: '', visitsReport: [] };
        }
        case SET_VISITS_REPORT_PAGINATION: {
            return { ...state, pagination: action.pagination };
        }
        case RESET_VISITS_REPORT: {
            return { ...INIT_STATE }
        }
        case FETCH_PAYMENTS_REPORT_START: {
            return { ...state, error: '', message: '', loading: true };
        }
        case FETCH_PAYMENTS_REPORT_SUCCESS: {
            //console.log('acion', action)
            return { ...state, error: '', message: '', loading: false, visitsReport: _.cloneDeep(action.visitsReport) };
        }
        case FETCH_PAYMENTS_REPORT_ERROR: {
            return { ...state, loading: false, error: action.error, message: '', visitsReport: [] };
        }
        case SET_PAYMENTS_REPORT_PAGINATION: {
            return { ...state, pagination: action.pagination };
        }
        case RESET_PAYMENTS_REPORT: {
            return { ...INIT_STATE }
        }
        default:
            return state;
    }
}

export default visitsReportReducer;
